import 'css-chunk:src/app/containers/Home/CommunitiesView/CommunitiesView.scss';export default {
  "CommunitiesView": "_CommunitiesView_j897g_1"
};